module.exports = function (value, defaultValue) {
  return value !== undefined ? value : defaultValue;
};